import '../../../styles/index.css'
import './BotaoAdicionar.css';
import PlusIconWhite from '../../../assets/icons/Plus Icon.svg';

function BotaoAdicionar({onClick}) {

    return (

        <button className='botaoAdicionar' onClick={onClick} data-cy="botao-adicionar-trigger">
            <img src={PlusIconWhite} alt="" />
            <span className='bt2'>Adicionar</span>
        </button>

    );
}

export default BotaoAdicionar;
